import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/ProjectWork.css";
import { Image, Row, Col } from "react-bootstrap";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import bin from "../../assets/icons/Bin.svg";
import changeIcon from "../../assets/icons/Group 2752.svg";
import Kebab from "../..//assets/icons/Kebab contacts.svg";
import XiconCircle from "../../assets/icons/x-circle.svg";
import calendar from "../../assets/icons/calendar.svg";
import upArrow from "../../assets/icons/upArrow.png";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import Loader from "../../components/Dailogs/Loader";
import AppDatePicker from "../../components/Common/AppDatePicker";
import moment from "moment";
import CurrencyInput from "react-currency-input";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import StockAssigneeModal from "../../pages/dynamic/StockAssigneeModal";

import {
  FetchPOByProject,
  DeleteOrder,
  UpdateOrderStatus,
  UpdateRentExpireDate,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../components/Pagination/Pagination";
import axios from "axios";
import { API_URL } from "../../redux/constants/type";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AddProjectRent = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const startingDate_Popup_Ref = useRef(null);
  const complitionDate_Popup_Ref = useRef(null);
  const kebab_Popup_Ref = useRef(null);
  const sortByRef = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const projectid = window.localStorage.getItem("projectid");
  const projectcode = window.localStorage.getItem("projectcode");
  const firstname = window.localStorage.getItem("firstname");
  const isViewer = process.env.REACT_APP_IS_VIEWER;
  console.log("ASC56 Role ENV", isViewer);

  const fetchPOByProjectResponse = useSelector(
    (state) => state.user.fetchPOByProjectResponse
  );

  const projectRentDeleteRes = useSelector(
    (state) => state.user.projectRentDeleteRes
  );

  const UpdateProjectRentStatusRes = useSelector(
    (state) => state.user.UpdateProjectRentStatusRes
  );

  const UpdateProjectRentExtendPeriodRes = useSelector(
    (state) => state.user.UpdateProjectRentExtendPeriodRes
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  // variables state management start
  const [hovereff, setHovereff] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [stockList, setStockList] = useState([]);
  const [kebabPopupShow, setKebabPopupShow] = useState(false);
  const [addTaskModalShow, setAddTaskModalShow] = useState(false);
  console.log("asc56", addTaskModalShow);

  // Header hiring update variables for kebab start.
  const [selectedOrderID, setSelectedOrderID] = useState("");
  const [changeStatusPopup, setChangeStatusPopup] = useState(false);
  // status by start.
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [statusShow, setStatusShow] = useState(false);
  const [status, setStatus] = useState("Select...");
  // status by end.

  const [addPopupShow, setAddPopupShow] = useState(false);
  const [extendPeriodPopup, setExtendPeriodPopup] = useState(false);
  const [requestSupplier, setRequestSupplier] = useState(false);
  const [chargeClient, setChargeClient] = useState(false);
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);
  const [startingDate, setStartingDate] = useState(new Date());
  const [expiryDate, setExpiryDate] = useState(new Date());
  const [dateError, setDateError] = useState(false);
  const [createdat, setCreatedat] = useState(new Date());
  const [wageRate, setWageRate] = useState("");
  const [wageType, setWageType] = useState("");
  const [projectHiringID, setProjectHiringID] = useState("");
  const [hiringID, setHiringID] = useState("");
  // Header hiring update variables for kebab end.

  // header pagination start 2nd.
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  // header pagination end 2nd.

  useEffect(() => {
    if (fetchPOByProjectResponse.status === true) {
      setStockList(fetchPOByProjectResponse.data);
      setShowLoader(false);

      // header pagination start 2nd.
      let pages = Math.ceil(
        fetchPOByProjectResponse?.totalCount / itemsPerPage
      );
      setTotalPages(pages);
      setTotalItems(fetchPOByProjectResponse?.totalCount);
      let array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      // header pagination end 2nd.
    }
  }, [fetchPOByProjectResponse]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      kebab_Popup_Ref.current &&
      !kebab_Popup_Ref.current.contains(event.target)
    ) {
      setKebabPopupShow(false);
      setArrowOptionsRotate(false);
    }

    if (sortByRef.current && !sortByRef.current.contains(event.target)) {
      setShowShortDrop(false);
    }

    if (
      startingDate_Popup_Ref.current &&
      !startingDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen(false);
    }
    if (
      complitionDate_Popup_Ref.current &&
      !complitionDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen2(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [companyShow, setCompanyShow] = useState(false);
  const [viewByTxtShow, setViewByTxtShow] = useState("Company");

  const [rentID, setRentID] = useState("");

  const [sortBy, setSortBy] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [isUpdateTime, setIsUpdateTime] = useState(false);

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedValue, setSortedValue] = useState("Start Date");

  // sort by options start
  const sortByOption = [
    { label: "Start Date", value: "Start Date" },
    { label: "End Date", value: "End Date" },
    { label: "Assignee", value: "Assignee" },
    { label: "Equipment", value: "Equipment" },
  ];
  // sort by options end

  useEffect(() => {
    const sortedPayload = shortByArrow
      ? `asc-${sortedValue}`
      : `dsc-${sortedValue}`;
    // dispatch(FetchProjectWorks(querystring, sortedPayload));
    // dispatch(FetchPOByProject(projectid, "Rent"));
    dispatch(FetchPOByProject(projectid, "Rent", pageNumber, itemsPerPage));
  }, [
    projectRentDeleteRes,
    UpdateProjectRentStatusRes,
    UpdateProjectRentExtendPeriodRes,
    querystring,
    sortBy,
    shortByArrow,
    sortedValue,
    pageNumber,
  ]);

  const [activeAllFromList, setActiveAllFromList] = useState(false);
  const [goComplete, setGoComplete] = useState("");

  // for complete Toggle start
  const [toggleComplete, setToggleComplete] = useState(false);
  const [ascTaskid, setAscTaskid] = useState("");
  const [currentIndex, setCurrentIndex] = useState(null);
  const [selectedToggle, setSelectedToggle] = useState([]);

  const [active, setActive] = useState(false);
  const [selectedTaskID, setSelectedTaskID] = useState("");
  console.log("asc563", selectedTaskID);
  // for complete Toggle end

  // header pagination start.
  // const [paginationObj, setPaginationObj] = useState({
  //   totalRecords: 0,
  //   currentPage: 0,
  //   startRecordIndex: 0,
  //   endRecordIndex: 0,
  //   totalPages: 0,
  //   records: [],
  // });
  // const itemsPerPage = 10;
  // const calculatePagination = (pageNumber) => {
  //   let records = stockList || [];
  //   let tempPaginationObj = {
  //     totalRecords: records.length,
  //     currentPage: pageNumber,
  //     startRecordIndex: Math.max(itemsPerPage * (pageNumber - 1) + 1, 1),
  //     endRecordIndex: Math.min(itemsPerPage * pageNumber, records.length),
  //     totalPages: Math.ceil(records.length / itemsPerPage),
  //     records: records.slice(
  //       (pageNumber - 1) * itemsPerPage,
  //       pageNumber * itemsPerPage
  //     ),
  //   };
  //   setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  // };
  // useEffect(() => {
  //   calculatePagination(1);
  // }, [stockList]);
  // header pagination end.

  return (
    <>
      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div className="parent pt-2 position-relative">
          <div className="outer w-100">
            <Row className="row-item px-4 pb-2">
              <Col xl={4} className="p-0">
                <div
                  onClick={() => {
                    setAddPopupShow(true);
                  }}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointer d-none position-relative"
                      : "pointer d-flex gap-2 p-3 pb-0 position-relative"
                  }
                  style={{ borderRadius: "8px" }}
                >
                  <img src={CardAddButton} className="addDocImg" alt="" />
                  <p className="createWork pt-1">
                    {/* Add Rent Purchase Order */}
                    {t("Add Rent Purchase Order")}
                  </p>
                </div>
              </Col>

              {addPopupShow && (
                <div className="rentPopup p-3 position-absolute">
                  <div className="kebabTxt pointer">
                    <div className="d-flex gap-2 pb-2 mb-1 justify-content-end">
                      <img
                        src={XiconCircle}
                        alt=""
                        width={14}
                        onClick={() => {
                          setAddPopupShow(false);
                        }}
                      />
                    </div>
                    <div
                      className="d-flex gap-2 mb-2 rent_material"
                      onClick={() =>
                        history.push("/add-rent-order", "/updateProject")
                      }
                    >
                      <p className="mb-0">
                        {/* Materials */}
                        {t("Materials")}
                      </p>
                    </div>
                    <div
                      className="d-flex gap-2 rent_material"
                      onClick={() => {
                        setAddPopupShow(false);
                      }}
                    >
                      <p className="mb-0">
                        {/* Equipment */}
                        {t("Equipment")}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <Col xl={4} className="p-0 invisible d-none d-xl-block">
                <sortSection
                  className="d-flex gap-3 p-3 pb-0"
                  style={{ position: "relative" }}
                >
                  <p className="sortBy">Sort by</p>
                  <img
                    className={
                      shortByArrow
                        ? "downSortArrow mt-1 pointer"
                        : "upSortArrow mt-1 pointer"
                    }
                    src={upArrow}
                    alt=""
                    onClick={() => {
                      setShortByArrow(!shortByArrow);
                    }}
                  />

                  <p
                    ref={sortByRef}
                    className="datetext pointer"
                    onClick={() => setShowShortDrop(!showShortDrop)}
                  >
                    {sortedValue ? sortedValue : "Select"}
                  </p>

                  <div
                    className="sortDropDiv p-3"
                    style={{
                      transform: showShortDrop ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                      left: "70px",
                      top: "0px",
                    }}
                  >
                    {sortByOption.map((item, index) => {
                      return (
                        <div
                          className={
                            sortedValue === item.label
                              ? "datetext pointer"
                              : "pointer"
                          }
                          onClick={() => {
                            setSortedValue(item.value);
                            setShowShortDrop(false);
                          }}
                        >
                          <p className="d-flex gap-">
                            {item.label}
                            {sortedValue === item.label && (
                              <p className="mb-0 ps-3">✓</p>
                            )}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </sortSection>
              </Col>

              <Col xl={4} className="add-col-item pe-0">
                <div className="p-3 pb-0">
                  {/* header pagination start */}
                  {/* <div className="stock-custom-pagination">
                    <div>
                      {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex}  of  ${paginationObj.totalRecords}`}
                    </div>
                    <div className="pagination-buttons">
                      <div
                        className={`update-stock-pagination-button ${
                          paginationObj.currentPage === 1 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          calculatePagination(paginationObj.currentPage - 1)
                        }
                      >
                        <BsChevronLeft />
                      </div>
                      <div className="pagination-current-page">
                        {paginationObj.currentPage}
                      </div>
                      <div
                        className={`update-stock-pagination-button ${
                          paginationObj.totalPages === 0 ||
                          paginationObj.totalPages === paginationObj.currentPage
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          calculatePagination(paginationObj.currentPage + 1)
                        }
                      >
                        <BsChevronRight />
                      </div>
                    </div>
                  </div> */}
                  {/* header pagination end */}

                  {/* header pagination start 2nd*/}
                  <section
                    className="fr quotes-div-sec-2 addstock-page-length  addstock-page-in-tablet"
                    style={{ gap: "7px" }}
                  >
                    <p>
                      {pageNumber === 1
                        ? 1
                        : itemsPerPage * (pageNumber - 1) + 1}
                      -
                      {itemsPerPage * pageNumber > totalItems
                        ? totalItems
                        : itemsPerPage * pageNumber}
                    </p>
                    <p>of</p>
                    <p>{totalItems}</p>
                    <p
                      className="aro-lr"
                      onClick={() => {
                        if (pageNumber === 1) return;
                        setPageNumber((p) => p - 1);
                      }}
                    >
                      {"<"}
                    </p>
                    <p className="quote-current-page">{pageNumber}</p>
                    <p
                      className="aro-lr"
                      onClick={() => {
                        if (pageNumber >= totalPages) return;
                        setPageNumber((p) => p + 1);
                      }}
                    >
                      {">"}
                    </p>
                  </section>
                </div>
              </Col>
            </Row>

            <div className="ascTableWrapper px-4">
              <table className="table">
                <thead>
                  <tr
                    className="tableHeading"
                    style={{
                      color: "#333333",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    <th>
                      {/* Type */}
                      {t("TYPE")}
                    </th>
                    <th>
                      {/* Date */}
                      {t("Date")}
                    </th>
                    <th>
                      {/* Rent <br />
                      Order ID */}
                      {t("Rent Order Id").slice(0, 5)}
                      <br />
                      {t("Rent Order Id").slice(5)}
                    </th>
                    <th style={{ width: "15%" }}>
                      {/* Supplier */}
                      {t("Supplier")}
                    </th>
                    <th>
                      {/* Total
                      <br />
                      excl. Btw */}
                      {t("Total excl. Btw").slice(0, 5)}
                      <br />
                      {t("Total excl. Btw").slice(5)}
                    </th>
                    <th>
                      {/* Period Start */}
                      {t("Period Start")}
                    </th>
                    <th>
                      {/* Period End */}
                      {t("Period End")}
                    </th>
                    <th style={{ width: "1%" }}>
                      {/* Status */}
                      {t("Status")}
                    </th>
                    <th></th>
                  </tr>
                </thead>

                <tbody
                  className="tabLine"
                  style={{
                    color: "#333333",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {stockList.map((item, index) => {
                    return (
                      <tr
                        className="asc_Table_Hover"
                        // title={item.clientname.length > 10 && item.clientname}
                      >
                        <td
                          // title={item?.workname?.length > 10 && item?.workname}
                          className="pointer"
                          // style={{
                          //   // for 3 dots 👇
                          //   // whiteSpace: "pre-wrap",
                          //   whiteSpace: "nowrap",
                          //   overflow: "hidden",
                          //   textOverflow: "ellipsis",
                          //   maxWidth: "10px",
                          // }}
                          onClick={() => {
                            setIsUpdateTime(true);
                            setRentID(item.orderid);
                            history.push({
                              pathname: `/view-rent-order/${item.ordercode}`,
                              state: {
                                from: "Rent Screen",
                                supplierid: item.supplierid,
                                projectname: item.projectname,
                                suppliername: item.suppliername,
                              },
                            });
                            window.localStorage.setItem(
                              "orderid",
                              item.orderid,
                            );
                          }}
                        >
                          {item.type || "Materials"}
                        </td>

                        <td className="">
                          {moment(item.createdat).format("DD.MM.YYYY")}
                        </td>
                        <td>{item.ordercode}</td>

                        <td
                          className=""
                          title={
                            item.suppliername.length > 10 && item.suppliername
                          }
                          style={{
                            // for 3 dots 👇
                            // whiteSpace: "pre-wrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "10px",
                          }}
                        >
                          {item.suppliername}
                        </td>

                        <td className="">
                          {europeanFormatWithSymbol(item.totalExclusiveBtw)}
                        </td>

                        <td className="">
                          {moment(item.rentPeriodFrom).format("DD.MM.YYYY")}
                        </td>

                        <td className="">
                          {moment(item.rentPeriodTo).format("DD.MM.YYYY")}
                        </td>

                        <td>{item.statusname}</td>

                        <td className="position-relative">
                          <img
                            className="pointer"
                            src={Kebab}
                            alt=""
                            onClick={() => {
                              setKebabPopupShow(true);
                              setSelectedOrderID(item.orderid);
                            }}
                          />
                          {kebabPopupShow &&
                            item.orderid === selectedOrderID && (
                              <div className="companyKebabPopup p-3">
                                <div className="pointer text-end pe-2">
                                  <img
                                    src={Kebab}
                                    alt=""
                                    style={{ rotate: "90deg" }}
                                    onClick={() => {
                                      setKebabPopupShow(false);
                                    }}
                                  />
                                </div>
                                <div className="kebabTxt pointer">
                                  <div
                                    className="d-flex gap-2 position-relative"
                                    style={{
                                      background:
                                        changeStatusPopup && "#F1F1F1",
                                      borderRadius: changeStatusPopup && "8px",
                                    }}
                                    onClick={() => {
                                      // history.push({
                                      //   pathname: "/add-contact",
                                      //   state: {
                                      //     from: "CompanyList_Screen",
                                      //     companyName: item.clientname,
                                      //   },
                                      // });
                                      setChangeStatusPopup(!changeStatusPopup);
                                      setExtendPeriodPopup(false);
                                    }}
                                  >
                                    <img src={changeIcon} alt="" width={14} />
                                    <p>Change Status</p>
                                  </div>

                                  {changeStatusPopup && (
                                    <div
                                      className="w-100"
                                      style={{
                                        position: "absolute",
                                        right: "170px",
                                        top: "45px",
                                        borderRadius: "8px",
                                      }}
                                    >
                                      <div
                                        className="p-2 text-end"
                                        style={{
                                          background: "#E1E1E1",
                                          borderRadius: "8px 8px 0px 0px",
                                        }}
                                      >
                                        <img
                                          src={XiconCircle}
                                          alt=""
                                          width={16}
                                          className="ms-auto"
                                          onClick={() => {
                                            setChangeStatusPopup(false);
                                          }}
                                        />
                                      </div>
                                      <div
                                        // ref={status_Popup_Ref}
                                        className="asc_Search_Box w-100 ms- d-flex pointer"
                                        style={{
                                          border: "unset",
                                          borderRadius: "unset",
                                          background: "white",
                                          height: "40px",
                                          paddingTop: "10px",
                                        }}
                                      >
                                        <p
                                          className="asc_Client_Input_For_Long ps-3 m-0"
                                          onClick={() => {
                                            setStatusShow(!statusShow);
                                            setArrowOptionsRotate3(
                                              !arrowOptionsRotate3,
                                            );
                                          }}
                                        >
                                          <p className="m-0 selectedTxT">
                                            {status}
                                          </p>
                                        </p>

                                        <img
                                          src={DownArrowOption}
                                          className={
                                            arrowOptionsRotate3
                                              ? "upArrow mt-1"
                                              : "downArrow mt-1"
                                          }
                                          alt=""
                                          onClick={() => {
                                            setStatusShow(!status);
                                            setArrowOptionsRotate3(
                                              !arrowOptionsRotate3,
                                            );
                                          }}
                                        />

                                        {statusShow && (
                                          <div
                                            className="asc_Custom_Select_Outer pt-1"
                                            style={{
                                              borderTop: "none",
                                              border: "unset",
                                              background: "white",
                                            }}
                                          >
                                            <div className="">
                                              <p
                                                className={
                                                  status === "Requested"
                                                    ? "asc_Selected_Item ps-3 py-1 mb-1 d-flex justify-content-between"
                                                    : "ps-3 py-1 mb-1 hoverItem"
                                                }
                                                style={{ boxShadow: "unset" }}
                                                onClick={() => {
                                                  setStatus("Requested");
                                                  setStatusShow(false);
                                                  setArrowOptionsRotate3(false);
                                                  dispatch(
                                                    UpdateOrderStatus(
                                                      item.orderid,
                                                      process.env
                                                        .REACT_APP_REQUESTED,
                                                    ),
                                                  );
                                                }}
                                              >
                                                Requested
                                                {status === "Requested" && (
                                                  <p className="m-0 pe-2">✔</p>
                                                )}
                                              </p>
                                              <p
                                                className={
                                                  status === "Returned"
                                                    ? "asc_Selected_Item ps-3 py-1 mb-2 d-flex justify-content-between"
                                                    : "ps-3 py-1 mb-2 hoverItem"
                                                }
                                                style={{ boxShadow: "unset" }}
                                                onClick={() => {
                                                  setStatus("Returned");
                                                  setStatusShow(false);
                                                  setArrowOptionsRotate3(false);
                                                  dispatch(
                                                    UpdateOrderStatus(
                                                      item.orderid,
                                                      process.env
                                                        .REACT_APP_RETURNED,
                                                    ),
                                                  );
                                                }}
                                              >
                                                Returned
                                                {status === "Returned" && (
                                                  <p className="m-0 pe-2">✔</p>
                                                )}
                                              </p>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div
                                    className="d-flex gap-2 position-relative"
                                    style={{
                                      background:
                                        extendPeriodPopup && "#F1F1F1",
                                      borderRadius: extendPeriodPopup && "8px",
                                    }}
                                    onClick={() => {
                                      // history.push({
                                      //   pathname: "/add-contact",
                                      //   state: {
                                      //     from: "CompanyList_Screen",
                                      //     companyName: item.clientname,
                                      //   },
                                      // });
                                      setExtendPeriodPopup(!extendPeriodPopup);
                                      setChangeStatusPopup(false);
                                    }}
                                  >
                                    <img src={calendar} alt="" width={14} />
                                    <p>Extend Period</p>
                                  </div>

                                  {extendPeriodPopup && (
                                    <div
                                      className=""
                                      style={{
                                        width: "400px",
                                        maxWidth: "40vw",
                                        position: "absolute",
                                        right: "200px",
                                        top: "45px",
                                        borderRadius: "8px",
                                        background: "#FFFFFF",
                                        boxShadow: "0px 6px 10px #3B455833",
                                      }}
                                    >
                                      <div
                                        className="d-flex justify-content-between p-1"
                                        style={{
                                          background: "#E4EDFA",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <p className="extend ps-3">
                                          Extend Rent Period
                                        </p>
                                        <img
                                          src={XiconCircle}
                                          alt=""
                                          width={18}
                                          className="me-2"
                                          onClick={() => {
                                            setExtendPeriodPopup(false);
                                          }}
                                        />
                                      </div>

                                      <div className="row pt-3 ps-3">
                                        <div className="col-12 col-md-5">
                                          <p className="my-2">
                                            New Expiring Date
                                          </p>
                                        </div>
                                        <div className="col-12 col-md-5">
                                          <div
                                            className="projectManagerInput ps-4 flexContainer"
                                            id="CalendarCssTT22"
                                            style={{
                                              border: "none",
                                              height: "40px",
                                            }}
                                            ref={startingDate_Popup_Ref}
                                          >
                                            <img
                                              className="calendarIcon pointer"
                                              onClick={() =>
                                                setCalendarIsOpen((p) => !p)
                                              }
                                              src={calendar}
                                              alt=""
                                            />
                                            <AppDatePicker
                                              open={calendarIsOpen}
                                              selected={expiryDate}
                                              onChange={(val) => {
                                                setExpiryDate(val);
                                                setCalendarIsOpen(false);
                                              }}
                                              onSelect={(d, event) => {
                                                setDateError(false);
                                                event.preventDefault();
                                              }}
                                              isError={dateError}
                                              error={setDateError}
                                              dateFormat="dd/MM/yyyy"
                                            />
                                          </div>
                                          {dateError && (
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "5px",
                                                marginTop: "5px",
                                              }}
                                            >
                                              <div class="warning-icon">!</div>
                                              <div class="warning-message">
                                                Please select a valid date.
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="row ps-3">
                                        <div className="col-12 col-md-5">
                                          <p className="my-2">
                                            Request To Supllier
                                          </p>
                                        </div>
                                        <div className="col-12 col-md-5">
                                          <div
                                            className="projectManagerInput ps-4 assign_Probability_project gap-3"
                                            style={{
                                              border: "none",
                                              height: "40px",
                                            }}
                                          >
                                            <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                                              <input
                                                type="radio"
                                                checked={
                                                  requestSupplier === true ||
                                                  requestSupplier === 1
                                                }
                                                style={{
                                                  fontSize: "12px",
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                // value={requestSupplier}
                                                onChange={(e) => {
                                                  setRequestSupplier(true);
                                                  // setTypeComp(e.target.value);
                                                }}
                                              />
                                              Yes
                                            </div>

                                            <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                                              <input
                                                type="radio"
                                                checked={
                                                  requestSupplier === false ||
                                                  requestSupplier === 0
                                                }
                                                style={{
                                                  fontSize: "12px",
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                // value={requestSupplier}
                                                onChange={(e) => {
                                                  setRequestSupplier(false);
                                                  // setTypeComp(e.target.value);
                                                }}
                                              />
                                              No
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="row ps-3">
                                        <div className="col-12 col-md-5">
                                          <p className="my-2">Charge Client</p>
                                        </div>
                                        <div className="col-12 col-md-5">
                                          <div
                                            className="projectManagerInput ps-4 assign_Probability_project gap-3"
                                            style={{
                                              border: "none",
                                              height: "40px",
                                            }}
                                          >
                                            <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                                              <input
                                                type="radio"
                                                checked={
                                                  chargeClient === true ||
                                                  chargeClient === 1
                                                }
                                                style={{
                                                  fontSize: "12px",
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                // value={chargeClient}
                                                onChange={(e) => {
                                                  // setChargeClient(e.target.checked);
                                                  setChargeClient(true);
                                                  // setTypeComp(e.target.value);
                                                }}
                                              />
                                              Yes
                                            </div>

                                            <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                                              <input
                                                type="radio"
                                                checked={
                                                  chargeClient === false ||
                                                  chargeClient === 0
                                                }
                                                style={{
                                                  fontSize: "12px",
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                // value={chargeClient}
                                                onChange={(e) => {
                                                  // setChargeClient(e.target.checked);
                                                  setChargeClient(false);
                                                  // setTypeComp(e.target.value);
                                                }}
                                              />
                                              No
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="my-3">
                                        <button
                                          id="ascButtonDisabled"
                                          className="button_invo mx-auto"
                                          onClick={(e) => {
                                            dispatch(
                                              UpdateRentExpireDate(
                                                item.orderid,
                                                expiryDate,
                                                // endingDate,
                                                // chargeClient
                                              ),
                                            );
                                            setExtendPeriodPopup(false);
                                          }}
                                        >
                                          <p>Add</p>
                                        </button>
                                      </div>
                                    </div>
                                  )}

                                  <div
                                    className="d-flex gap-2"
                                    onClick={() => {
                                      // history.push({
                                      //   pathname: "/addProject",
                                      //   state: "/project",
                                      //   ascState: {
                                      //     from: "CompanyList_Screen",
                                      //     clientName: item.clientname,
                                      //     clientId: item.clientid,
                                      //   },
                                      // });
                                      dispatch(DeleteOrder(item.orderid));
                                    }}
                                  >
                                    <img src={bin} alt="" width={14} />
                                    <p>Delete</p>
                                  </div>
                                </div>
                              </div>
                            )}
                        </td>
                      </tr>
                    );
                  })}
                  {stockList.length === 0 && (
                    <span className="noDataDisplay">
                      {/* No data to display! */}
                      {t("No data to display!\n")}
                    </span>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddProjectRent;
